import {Grid} from '@logistics-frontend/blocks'
import {FormControlLabel} from '@logistics-frontend/blocks/lpc/form-control-label'
import {Switch} from '@logistics-frontend/blocks/lpc/switch'
import {Tooltip} from '@logistics-frontend/blocks/lpc/tooltip'
import {useI18n} from '@logistics-frontend/core/i18n'
import {makeStyles} from '@material-ui/core/styles'
import {useRequirementValue} from '@yandex-taxi/react-integration-api'
import React, {useCallback, useEffect} from 'react'

import {useRequirementGoalCallback} from '../../../../shared/metrika'
import {Tariff} from '../../../consts'
import {Props, RequirementName} from './types'

const useClasses = makeStyles(
  theme => ({
    error: {},
    track: {
      '$error &': {
        backgroundColor: theme.palette.error.main,
      },
    },
  }),
  {name: 'BooleanRequirement'},
)

const BooleanRequirement: React.FC<Props> = ({requirement, tariff}) => {
  const t = useI18n()
  const {name, default: defaultValue} = requirement
  const {error: errorClassName, ...classes} = useClasses()
  const [{value, touched, error}, {setValue, setTouched}] = useRequirementValue<boolean>(name)
  const goalCallback = useRequirementGoalCallback(tariff, name)
  const changeHandler = useCallback(() => {
    const nextValue = !value

    setValue(nextValue)
    setTouched(true)
    goalCallback(nextValue)
  }, [goalCallback, setTouched, setValue, value])
  const disabled = name === RequirementName.DOOR_2_DOOR && tariff === Tariff.COURIER
  const controlValue = value === undefined ? (defaultValue as boolean) : value
  const control = (
    <FormControlLabel
      control={
        <Switch
          checked={controlValue}
          classes={classes}
          className={!!(touched && error) ? errorClassName : undefined}
          disabled={disabled}
          onChange={disabled ? undefined : changeHandler}
        />
      }
      label={requirement.label}
    />
  )

  useEffect(() => {
    if (name === RequirementName.DOOR_2_DOOR && value === undefined) {
      setValue(true)
    }
  }, [name, setValue, value])

  return (
    <Grid spacing={1} container>
      <Grid xs={12} item>
        {disabled ? (
          <Tooltip
            placement="right"
            title={t('order.form.from_door_to_door_message', 'Опция «От двери до двери» всегда включена в тариф')}
            arrow
          >
            {control}
          </Tooltip>
        ) : (
          control
        )}
      </Grid>
    </Grid>
  )
}

export default BooleanRequirement
